import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ResourceGroupService } from '../../../../service/services/rest/resource-group/resource-group.service';
import { ResourceGroupModel } from '../../../../core/models/resources/resource-group.model';
import { BaseCreateDialogComponent } from '../../../../core/components/abstract/base-create-dialog/base-create-dialog.component';
import { Utils } from '../../../../core/helpers/Utils';
import { SideDialogComponent } from '../../../../shared/components/side-dialog/side-dialog.component';
import { SwaService } from '../../../../service/services/misc/swa/swa.service';
import {DialogService} from "../../../../service/services/misc/dialog/dialog.service";
import {UisService} from "../../../../service/services/misc/uis/uis.service";

@Component({
    selector: 'app-create-resource-group-side-dialog',
    templateUrl: './create-resource-group-dialog.component.html',
    styleUrls: ['./create-resource-group-dialog.component.scss'],
    standalone: false
})
export class CreateResourceGroupDialogComponent extends BaseCreateDialogComponent implements OnInit {
	@ViewChild('dialog') private dialog: SideDialogComponent;

	constructor(
		public override dialogRef: DialogRef,
    public override dialogService: DialogService,
		protected override notificationsService: NotificationsService,
		protected override fb: UntypedFormBuilder,
		protected override cdRef: ChangeDetectorRef,
		private resourceGroupService: ResourceGroupService,
		protected override _swaService: SwaService,
		protected override _uisService: UisService
	) {
	    super(dialogRef, dialogService, notificationsService, fb, cdRef, _swaService, _uisService);
	    this.form.addControl('displayName', new UntypedFormControl('', Validators.required));
	}

	override onSubmit() {
	    this.sendEvent('Resource Group', this.form.getRawValue().name, this.isEdit);
	    this.setLoading(true);
	    let resourceGroup = new ResourceGroupModel({
	        name: this.form.getRawValue().name,
	        displayName: this.form.getRawValue().displayName,
	        description: this.form.getRawValue().description,
	        path: this.dialogRef.data.resource.path,
	        labels: Utils.convertLabels(this.labels),
	        annotations: Utils.convertLabels(this.annotations),
	    });

	    let resourceMethod = this.isEdit
	        ? this.resourceGroupService.update(resourceGroup.path, resourceGroup.name, resourceGroup)
	        : this.resourceGroupService.add(resourceGroup.path, resourceGroup.name, resourceGroup);
	    return resourceMethod
	        .subscribe({
	            next: this.onSuccess.bind(this),
	            error: this.onError.bind(this, this.dialog)
	        })
	        .add(() => {
	            this.setLoading(false);
	        });
	}
}
